import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import _defineProperty from "/home/daniel/Proyectos/gcom/frontend/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import QCheckbox from "../checkbox/QCheckbox.js";
export default {
  methods: {
    __getTBodyTR: function __getTBodyTR(h, row, bodySlot, pageIndex) {
      var _this = this;

      var key = this.getRowKey(row),
          selected = this.isRowSelected(key);

      if (bodySlot !== void 0) {
        return bodySlot(this.__getBodyScope({
          key: key,
          row: row,
          pageIndex: pageIndex,
          __trClass: selected ? 'selected' : ''
        }));
      }

      var bodyCell = this.$scopedSlots['body-cell'],
          child = this.computedCols.map(function (col) {
        var bodyCellCol = _this.$scopedSlots["body-cell-".concat(col.name)],
            slot = bodyCellCol !== void 0 ? bodyCellCol : bodyCell;

        return slot !== void 0 ? slot(_this.__getBodyCellScope({
          key: key,
          row: row,
          pageIndex: pageIndex,
          col: col
        })) : h('td', {
          class: col.__tdClass,
          style: col.style
        }, _this.getCellValue(col, row));
      });

      if (this.hasSelectionMode === true) {
        var slot = this.$scopedSlots['body-selection'];
        var content = slot !== void 0 ? slot(this.__getBodySelectionScope({
          key: key,
          row: row,
          pageIndex: pageIndex
        })) : [h(QCheckbox, {
          props: {
            value: selected,
            color: this.color,
            dark: this.isDark,
            dense: this.dense
          },
          on: {
            input: function input(adding, evt) {
              _this.__updateSelection([key], [row], adding, evt);
            }
          }
        })];
        child.unshift(h('td', {
          staticClass: 'q-table--col-auto-width'
        }, content));
      }

      var data = {
        key: key,
        class: {
          selected: selected
        },
        on: {}
      };

      if (this.qListeners['row-click'] !== void 0) {
        data.class['cursor-pointer'] = true;

        data.on.click = function (evt) {
          _this.$emit('row-click', evt, row, pageIndex);
        };
      }

      if (this.qListeners['row-dblclick'] !== void 0) {
        data.class['cursor-pointer'] = true;

        data.on.dblclick = function (evt) {
          _this.$emit('row-dblclick', evt, row, pageIndex);
        };
      }

      if (this.qListeners['row-contextmenu'] !== void 0) {
        data.class['cursor-pointer'] = true;

        data.on.contextmenu = function (evt) {
          _this.$emit('row-contextmenu', evt, row, pageIndex);
        };
      }

      return h('tr', data, child);
    },
    __getTBody: function __getTBody(h) {
      var _this2 = this;

      var body = this.$scopedSlots.body,
          topRow = this.$scopedSlots['top-row'],
          bottomRow = this.$scopedSlots['bottom-row'];
      var child = this.computedRows.map(function (row, pageIndex) {
        return _this2.__getTBodyTR(h, row, body, pageIndex);
      });

      if (topRow !== void 0) {
        child = topRow({
          cols: this.computedCols
        }).concat(child);
      }

      if (bottomRow !== void 0) {
        child = child.concat(bottomRow({
          cols: this.computedCols
        }));
      }

      return h('tbody', child);
    },
    __getVirtualTBodyTR: function __getVirtualTBodyTR(h) {
      var _this3 = this;

      var body = this.$scopedSlots.body;
      return function (props) {
        return _this3.__getTBodyTR(h, props.item, body, props.index);
      };
    },
    __getBodyScope: function __getBodyScope(data) {
      var _this4 = this;

      this.__injectBodyCommonScope(data);

      data.cols = data.cols.map(function (col) {
        var c = _objectSpread({}, col);

        Object.defineProperty(c, 'value', {
          get: function get() {
            return _this4.getCellValue(col, data.row);
          },
          configurable: true,
          enumerable: true
        });
        return c;
      });
      return data;
    },
    __getBodyCellScope: function __getBodyCellScope(data) {
      var _this5 = this;

      this.__injectBodyCommonScope(data);

      Object.defineProperty(data, 'value', {
        get: function get() {
          return _this5.getCellValue(data.col, data.row);
        },
        configurable: true,
        enumerable: true
      });
      return data;
    },
    __getBodySelectionScope: function __getBodySelectionScope(data) {
      this.__injectBodyCommonScope(data);

      return data;
    },
    __injectBodyCommonScope: function __injectBodyCommonScope(data) {
      var _this6 = this;

      Object.assign(data, {
        cols: this.computedCols,
        colsMap: this.computedColsMap,
        sort: this.sort,
        rowIndex: this.firstRowIndex + data.pageIndex,
        color: this.color,
        dark: this.isDark,
        dense: this.dense
      });
      this.hasSelectionMode === true && Object.defineProperty(data, 'selected', {
        get: function get() {
          return _this6.isRowSelected(data.key);
        },
        set: function set(adding, evt) {
          _this6.__updateSelection([data.key], [data.row], adding, evt);
        },
        configurable: true,
        enumerable: true
      });
      Object.defineProperty(data, 'expand', {
        get: function get() {
          return _this6.isRowExpanded(data.key);
        },
        set: function set(adding) {
          _this6.__updateExpanded(data.key, adding);
        },
        configurable: true,
        enumerable: true
      });
    },
    getCellValue: function getCellValue(col, row) {
      var val = typeof col.field === 'function' ? col.field(row) : row[col.field];
      return col.format !== void 0 ? col.format(val, row) : val;
    }
  }
};